var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 6.3H8.80005V0.699957C8.80005 0.313641 8.4416 0 7.99995 0C7.55845 0 7.2 0.313641 7.2 0.699957V6.3H0.799951C0.358447 6.3 0 6.61364 0 6.99996C0 7.3864 0.358447 7.70004 0.799951 7.70004H7.2V13.3C7.2 13.6864 7.55845 14 7.99995 14C8.4416 14 8.80005 13.6864 8.80005 13.3V7.70004H15.2C15.6416 7.70004 16 7.3864 16 6.99996C16 6.61364 15.6416 6.3 15.2 6.3Z",
    fill: "#E96F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMore);
export default __webpack_public_path__ + "static/media/add_more.db33d3aa5d6469d2974e8ecff1ae6ddc.svg";
export { ForwardRef as ReactComponent };